// TODO: Is a temporary solution since the current library in use does not know how to work with a custom date for cookies https://github.com/marcuswestin/store.js/blob/b8e22fea8738fc19da4d9e7dbf1cda6e5185c481/storages/cookieStorage.js#L43
/**
 * Writes data to cookies
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - The number of days for which cookies are written
 */
export const setCookie = (name: string, value: string, days: number) => {
    const date: Date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
};
